import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { COLORS } from 'theme/theme'

export const noMarginTop = css`
  margin-top: 0;
`

export const Title = styled.h4`
  color: ${COLORS.darkBlue};
  margin-top: 35px;
  margin-bottom: 2px;
  text-transform: uppercase;
`
